import { Button } from '@journ/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@journ/ui/dropdown-menu'
import { Icons } from '@journ/ui/icons'
import { Link } from '@/libs/router'
import { useIntlayer } from 'react-intlayer'
import { showArchive$, showCancel$, showReject$ } from '../../work-item-detail-store'
import { useWorkItemDetailContext } from './work-item-detail-context'

const WorkItemHeader = () => {
	const { workflow, detail } = useWorkItemDetailContext()
	const { item, actorCan, startWork, pauseWork, accept, reopen, complete, openEdit } = detail
	const c = useIntlayer('work-item').detail
	const ce = useIntlayer('work-item').edit

	if (!item) return null

	const hasMenuActions =
		actorCan.reject || actorCan.cancel || actorCan.archive || actorCan.complete || openEdit !== undefined

	const primaryAction = actorCan.start ? (
		<Button size='sm' onClick={() => startWork(item)} className='gap-1.5'>
			<Icons.Play className='size-3.5' />
			{c.startAction}
		</Button>
	) : actorCan.pause ? (
		<Button size='sm' variant='outline' onClick={() => pauseWork(item)} className='gap-1.5'>
			<Icons.Stop className='size-3.5' />
			{c.pauseAction}
		</Button>
	) : actorCan.accept ? (
		<Button size='sm' onClick={() => accept(item)} className='gap-1.5'>
			<Icons.Check className='size-3.5' />
			{c.acceptAction}
		</Button>
	) : actorCan.reopen ? (
		<Button size='sm' variant='outline' onClick={() => reopen(item)} className='gap-1.5'>
			<Icons.Refresh className='size-3.5' />
			{c.reopenAction}
		</Button>
	) : null

	return (
		<div className='flex items-center justify-between gap-4'>
			<div className='flex items-center gap-2 text-sm text-606060 min-w-0'>
				<Link to='/tasks/$workflow-id' params={{ 'workflow-id': workflow.id }} className='hover:text-foreground'>
					{workflow.name}
				</Link>
				<span>/</span>
				<span className='truncate text-foreground'>{item.externalId ?? item.title}</span>
			</div>
			<div className='flex items-center gap-2 shrink-0'>
				{primaryAction}
				{hasMenuActions ? (
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<Button
								size='icon'
								variant='ghost'
								aria-label={c.moreActionsLabel.value}
								className='p-0 m-0 size-auto hover:bg-transparent'
							>
								<Icons.MoreVertical className='size-5' />
							</Button>
						</DropdownMenuTrigger>
						<DropdownMenuContent align='end'>
							{actorCan.complete ? (
								<DropdownMenuItem onSelect={() => complete(item)}>{c.completeAction}</DropdownMenuItem>
							) : null}
							{openEdit ? (
								<DropdownMenuItem onSelect={openEdit}>{c.editAction}</DropdownMenuItem>
							) : null}
							{actorCan.reject ? (
								<DropdownMenuItem onSelect={() => showReject$.set(true)}>{c.rejectAction}</DropdownMenuItem>
							) : null}
							{actorCan.cancel ? (
								<DropdownMenuItem onSelect={() => showCancel$.set(true)}>{c.cancelAction}</DropdownMenuItem>
							) : null}
							{actorCan.archive ? (
								<DropdownMenuItem onSelect={() => showArchive$.set(true)}>{c.archiveAction}</DropdownMenuItem>
							) : null}
							{!item.parentId ? (
								<DropdownMenuItem onSelect={openEdit}>{ce.reassignLabel}</DropdownMenuItem>
							) : null}
						</DropdownMenuContent>
					</DropdownMenu>
				) : null}
			</div>
		</div>
	)
}

export { WorkItemHeader }
